import type { CustomThemeDecoration, Decoration } from '../types';
import { DecorationLayer } from './DecorationLayer';
import { DecorationSpecFromCustom } from './DecorationSpecFromCustom';

// v2 §D1 + tasks/46 §D5: renders the active theme's decoration.
//
// Preset themes flow through the historical `Decoration` union
// (bespoke React component or single-sprite spec). Custom-library
// themes carry a multi-sprite `CustomThemeDecoration` on the runtime
// Theme (`theme.source === 'custom'`, populated by `buildCustomTheme`)
// and route through `<DecorationSpecFromCustom>` so the wrapper can
// compose or randomly pick sprites without every caller knowing.
interface DecorationRendererProps {
  readonly decoration: Decoration | undefined;
  readonly customDecoration?: CustomThemeDecoration;
  readonly themeKey?: string;
  readonly routineId?: string;
}

export function DecorationRenderer({
  decoration,
  customDecoration,
  themeKey,
  routineId,
}: DecorationRendererProps) {
  if (customDecoration && themeKey) {
    return (
      <DecorationSpecFromCustom
        decoration={customDecoration}
        themeKey={themeKey}
        {...(routineId ? { routineId } : {})}
      />
    );
  }
  if (!decoration) return null;
  if (decoration.kind === 'component') {
    const Component = decoration.component;
    return <Component />;
  }
  return <DecorationLayer spec={decoration.spec} />;
}
